/** Legal pack: retained inventory, upload, managed analysis, prepared documents. */
import type { EndpointDef } from '../endpointTypes'

export const legalRoutes = {
  legalPacks: { method: 'GET', path: '/api/properties/:propertyId/legal-pack', note: 'Retained archives and documents (prepared assets, processing status)' },
  legalPackUpload: { method: 'POST', path: '/api/properties/:propertyId/legal-pack', note: 'multipart upload (complete ZIP snapshot)' },
  legalAnalysisCurrent: { method: 'GET', path: '/api/properties/:propertyId/legal-analysis/current', note: 'The result authority' },
  legalAnalysisRequest: { method: 'POST', path: '/api/properties/:propertyId/legal-analysis/request' },
  legalPackDocuments: { method: 'GET', path: '/api/legal-pack-documents', note: 'Prefix; document pages and images hang off it' },
} as const satisfies Record<string, EndpointDef>
